import { IOrder } from '../orders/order';
import { ICurrency } from '../structure';

export enum BasketType {
  CHECKOUT = 0,
  WATCH_LIST = 1,
  REQUEST_LIST = 2,
  IMAGE_DELIVERY_LIST = 3,
  PROJECTS = 4,
  DIRECT_ORDER_FORM = 5,
  ALBUMS = 6,
  MY_GARDEN = 7,
  MY_PETS = 8
}

export enum BasketState {
  OPEN = 0,
  CLOSED = 1
}

export enum ShippingStrategy {
  MINIMUM_SHIPPING = 0,
  FASTEST_SHIPPING = 1
}

export interface IBasket {
  basketID: number;
  type: BasketType;
  totalCosts: number;
  /**
   * Total costs without the shipping-related costs, which are only settled in the checkout. Shown as the
   * total in the cart sidebar panel, whose summary states exactly that. The cart page and the checkout
   * keep using `totalCosts` including those costs.
   */
  totalCostsWithoutShipping?: number;
  shippingStrategy: ShippingStrategy;
  state: BasketState;
  order: IOrder;
  currency: ICurrency;
  parent: IBasket;
  count: number;
}
export interface ICheckoutBasket {
  /** ID of the basket */
  basketID: number;
  /** Amount of items in the basket */
  count: number;
  /** currency object */
  currency: {
    /** Short name of the currency */
    nameShort: string;
    /** The sign of the currency */
    sign: string;
    /** ID of the currency */
    iD: number;
  };
  /** Total cost of the shoppingcart */
  totalCosts: number;
  /** Type ??? */
  type: number;
}
